import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d2b66d8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d2b66d8c&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=d2b66d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b66d8c",
  null
  
)

export default component.exports